import { MediaDto } from "./AdditionalDataTypes";
import { STORY_TYPE } from "./StoryTypeEnum";

export interface PlaylistContentDto {
    Title: string,
    Description: string,
    ListOfStories: Array<any>,
    Localization: { [key: string]: string }
}

export interface PlaylistStoryDto {
    KeyId: string,
    Title: string,
    Type: number,
    ViewDuration: number,
    Content: string,
    Storyteller : StorytellerDto,
    PreviewColor: string,
    PreviewImage: MediaDto,
    ContentMedia: Array<MediaDto>,
    Subtitles: Array<PlaylsitStorySubtitlesDto>,
    Poster: MediaDto
}

export interface PlaylsitStorySubtitlesDto {
    KeyId: string,
    SubtitlesFile: string,
    SubtitlesTitle: string,
    SubtitlesLang: string
}

export interface StorytellerDto {
    Name: string,
    Image: MediaDto
}

export class PlaylistTimerDto {
    Element;
    ViewDuration;
    StoryType

    constructor(element: HTMLElement | HTMLVideoElement | null, duration: number | null, StoryType: STORY_TYPE) {
        this.Element = element;
        this.ViewDuration = duration;
        this.StoryType = StoryType;
    }
    
}

export abstract class PlaylistConstants {
    static readonly DEFAULT_DURATION = 15000;
    static readonly VIDEO_SWITCH_DURATION = 1;
}